let getAssessmentResultObj = (theme) => {
  return {
    buttonStyle: (isMobile) => ({
      padding: isMobile ? "8px 12px" : "10px 20px",
      backgroundColor: "#0D47A1",
      marginTop: isMobile ? "20px" : "0px",
    }),
    briefDataStyle: (isMobile) => ({
      marginBottom: "15px",
      mt: "10px",
      display: "flex",
      alignItems: "center",
      backgroundColor: "white",
      border: "1px solid #EEEEEE",
      borderRadius: "16px",
      padding: isMobile ? "8px" : "16px",
      justifyContent: "space-around",
    }),
    briefDataBoxStyle: (isMobile, last) => ({
      borderRight: last ? "" : "1px solid #EEEEEE",
      padding: isMobile ? "8px" : "8px 16px",
      width: "100%",
    }),
    warningBoxStyle: () => ({
      backgroundColor: "#FFF7E5",
      border: "1px solid #FBC02D33",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      padding: "8px 16px",
      mt: "20px",
    }),
    sectionStyle: () => ({
      display: "flex",
      justifyContent: "space-between",
      padding: "16px 24px",
      backgroundColor: "#E3F2FD",
      alignItems: "center",
      borderRadius: "4px",
      gap: 2,
    }),

    injectPrintStyles: () => {
      const printStyles = `
        @media print {
          body {
            background-color: #ffffff !important;
          }
          @page {
            margin-left:0;
            margin-right:15px;
            @bottom-right {
              content: "Page " counter(page) " of " counter(pages);
            }
          }
          header, #footer-id {
            display: none !important;
          }
        }
      `;
      const styleElement = document.createElement("style");
      styleElement.textContent = printStyles;
      document.head.appendChild(styleElement);
    },
  };
};

export const getAssessmentResultStyle = getAssessmentResultObj;
